module.exports = __webpack_public_path__ + "img/save.4fb99e40.svg";